import * as Fn from 'effect/Function';

export const getGrouped: {
  (groupSize: number): (self: string) => ReadonlyArray<string>;
  (self: string, groupSize: number): ReadonlyArray<string>;
} = Fn.dual(2, (self: string, groupSize: number) =>
  _getGrouped(self, groupSize),
);

/**
 * @param str The string to group
 * @param size The maximum group size
 *
 * @returns
 * An array of strings where each item has a maximum length of `size`.
 */
function _getGrouped(str: string, size: number): string[] {
  if (size === 0) {
    throw new Error('groupSize must be bigger than 0');
  }

  const result = [];
  const { length } = str;

  for (
    let start = 0, end = start + size;
    start < length;
    start = end, end = start + size
  ) {
    result.push(str.slice(start, end));
  }

  return result;
}
